import axios from "axios";
import { apiURL } from "../config/config";
import { redirectToLoginAfterSessionExpiry } from "./apiSession";

const request = async (method, path, data, signal) => {
  try {
    const response = await axios({
      method, url: `${apiURL}${path}`, signal,
      ...(data === undefined ? {} : { data }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        ...(method === "put" ? { "Content-Type": "application/json" } : {}),
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) redirectToLoginAfterSessionExpiry();
    throw error;
  }
};

export const getHandover = (id, signal) => request("get", `quotations/${id}/handover`, undefined, signal);
export const getHandoverDefaults = (id, signal) => request("get", `quotations/${id}/handover/defaults`, undefined, signal);
export const saveHandover = (id, values, signal) => request("put", `quotations/${id}/handover`, values, signal);
export const getHandoverClients = async (signal) => {
  const clients = await request("get", "clients", undefined, signal);
  // ClientManagement consumes the direct array returned by this endpoint.
  if (!Array.isArray(clients)) throw new Error("รูปแบบรายการบริษัทไม่ถูกต้อง กรุณาลองใหม่");
  return clients;
};
export const getHandoverQuotation = (id, signal) => request("get", `quotations/${id}`, undefined, signal);

export const handoverErrorMessage = (error) => {
  const status = error.response?.status;
  const message = error.response?.data?.message;
  if (status === 401) return "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่";
  if (status === 403) return `ไม่มีสิทธิ์ใช้งานหนังสือส่งมอบงาน${message ? `: ${message}` : ""}`;
  if (status === 404) return `ไม่พบข้อมูล${message ? `: ${message}` : ""}`;
  return message || error.message || "เกิดข้อผิดพลาด กรุณาลองใหม่";
};
